module.exports = __webpack_public_path__ + "static/img/igede.bf98f0b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonial/igede.jpeg
// module id = gjmS
// module chunks = 1